"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useContext, useMemo, useState } from "react";
import SecondaryButton from "@/components/utils/button/SecondaryButton";
import MyStreamWaveMyVotesResetProgress from "./MyStreamWaveMyVotesResetProgress";
import { commonApiPost } from "@/services/api/common-api";
import type { DropRateChangeRequest } from "@/entities/IDrop";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import { useMutation } from "@tanstack/react-query";
import { AuthContext } from "@/components/auth/Auth";
import { formatNumberWithCommas } from "@/helpers/Helpers";
interface MyStreamWaveMyVotesResetProps {
  readonly haveDrops: boolean;
  readonly availableVotes?: number | null;
  readonly selected: Set<string>;
  readonly allItemsSelected: boolean;
  readonly onToggleSelectAll: () => void;
  readonly removeSelected: (dropId: string) => void;
  readonly onResettingChange: (isResetting: boolean) => void;
}
const DEFAULT_DROP_RATE_CATEGORY = "Rep";
const MyStreamWaveMyVotesReset: React.FC<MyStreamWaveMyVotesResetProps> = t0 => {
  const $ = _c(36);
  const {
    haveDrops,
    availableVotes: t1,
    selected,
    allItemsSelected,
    onToggleSelectAll,
    removeSelected,
    onResettingChange
  } = t0;
  const availableVotes = t1 === undefined ? null : t1;
  const {
    setToast
  } = useContext(AuthContext);
  const [isResetting, setIsResetting] = useState(false);
  const [resetProgress, setResetProgress] = useState(0);
  const selectedCount = selected.size;
  let t2;
  if ($[0] !== removeSelected) {
    t2 = response => {
      removeSelected(response.id);
    };
    $[0] = removeSelected;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== setToast) {
    t3 = error => {
      setToast({
        message: error as unknown as string,
        type: "error"
      });
      throw error;
    };
    $[2] = setToast;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2 || $[5] !== t3) {
    t4 = {
      mutationFn: _temp,
      onSuccess: t2,
      onError: t3
    };
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const rateChangeMutation = useMutation(t4);
  const [totalCount, setTotalCount] = useState(0);
  let t5;
  if ($[7] !== isResetting || $[8] !== onResettingChange || $[9] !== rateChangeMutation || $[10] !== selected || $[11] !== selectedCount) {
    t5 = async () => {
      if (!selectedCount || isResetting) {
        return;
      }
      setTotalCount(selectedCount);
      onResettingChange(true);
      setIsResetting(true);
      setResetProgress(0);
      const selectedDropIds = Array.from(selected);
      for (const dropId of selectedDropIds) {
        await rateChangeMutation.mutateAsync({
          dropId
        });
        setResetProgress(_temp2);
      }
      setIsResetting(false);
      setResetProgress(0);
      onResettingChange(false);
      setTotalCount(0);
    };
    $[7] = isResetting;
    $[8] = onResettingChange;
    $[9] = rateChangeMutation;
    $[10] = selected;
    $[11] = selectedCount;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const handleReset = t5;
  if (!haveDrops) {
    return null;
  }
  const t6 = allItemsSelected ? "Deselect All" : "Select All";
  let t7;
  if ($[13] !== isResetting || $[14] !== onToggleSelectAll || $[15] !== t6) {
    t7 = <SecondaryButton onClicked={onToggleSelectAll} size="sm" disabled={isResetting}>{t6}</SecondaryButton>;
    $[13] = isResetting;
    $[14] = onToggleSelectAll;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  const t8 = !selectedCount || isResetting;
  const t9 = isResetting ? "Resetting..." : "Reset Votes";
  let t10;
  if ($[17] !== handleReset || $[18] !== t8 || $[19] !== t9) {
    t10 = <SecondaryButton onClicked={handleReset} size="sm" disabled={t8}>{t9}</SecondaryButton>;
    $[17] = handleReset;
    $[18] = t8;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10 || $[22] !== t7) {
    t11 = <div className="tw-flex tw-items-center tw-gap-x-2">{t7}{t10}</div>;
    $[21] = t10;
    $[22] = t7;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== availableVotes) {
    t12 = typeof availableVotes === "number" && <p className="tw-mb-0 tw-text-xs tw-text-iron-500">Available{" "}<span className="tw-tabular-nums tw-text-iron-300">{formatNumberWithCommas(availableVotes)}</span></p>;
    $[24] = availableVotes;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t11 || $[27] !== t12) {
    t13 = <div className="tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-gap-x-4 tw-gap-y-2">{t11}{t12}</div>;
    $[26] = t11;
    $[27] = t12;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== isResetting || $[30] !== resetProgress || $[31] !== totalCount) {
    t14 = <MyStreamWaveMyVotesResetProgress isResetting={isResetting} resetProgress={resetProgress} totalCount={totalCount} />;
    $[29] = isResetting;
    $[30] = resetProgress;
    $[31] = totalCount;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== t13 || $[34] !== t14) {
    t15 = <div className="tw-pl-1">{t13}{t14}</div>;
    $[33] = t13;
    $[34] = t14;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  return t15;
};
export default MyStreamWaveMyVotesReset;
async function _temp(param) {
  return await commonApiPost({
    endpoint: `drops/${param.dropId}/ratings`,
    body: {
      rating: 0,
      category: DEFAULT_DROP_RATE_CATEGORY
    }
  });
}
function _temp2(prev) {
  return prev + 1;
}